import { buildOrganizationNode } from 'utils/structuredData/organization';

const COLLECTION_TYPENAME = 'ContentfulWebCollectionOfParagraphsLists';

const extractQuestions = sections => {
  const questions = [];
  for (const section of sections || []) {
    if (section?.__typename !== COLLECTION_TYPENAME) continue;
    for (const collection of section.collections || []) {
      for (const para of collection.paragraphs || []) {
        const question = para?.headline;
        const answerHtml = para?.paragraph?.childMarkdownRemark?.html;
        if (!question || !answerHtml) continue;
        questions.push({
          '@type': 'Question',
          name: question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: answerHtml,
          },
        });
      }
    }
  }
  return questions;
};

export const buildFaqStructuredData = ({
  sections,
  pathname,
  siteUrl,
  siteName,
  siteDescription,
  logoUrl,
  alternateName,
  parentOrganization,
  contactPoint,
  address,
}) => {
  const questions = extractQuestions(sections);
  if (!questions.length) return null;

  const baseUrl = String(siteUrl || '').replace(/\/$/, '');
  const url = `${baseUrl}${pathname || ''}`;

  return {
    '@context': 'https://schema.org',
    '@graph': [
      buildOrganizationNode({
        siteUrl,
        siteName,
        description: siteDescription,
        logoUrl,
        alternateName,
        parentOrganization,
        contactPoint,
        address,
      }),
      {
        '@type': 'FAQPage',
        '@id': `${url}#faq`,
        url,
        mainEntity: questions,
      },
    ],
  };
};
